import { render, staticRenderFns } from "./VFilePreview.vue?vue&type=template&id=1527db4e&"
import script from "./VFilePreview.vue?vue&type=script&lang=js&"
export * from "./VFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./VFilePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports